import { Link, NavLink, useNavigate } from 'react-router-dom';
import ColorModeToggle from './ColorModeToggle';
import { isDemoAuthenticated, logoutDemo } from '../utils/demoAuth';

const APP_LINKS = [
  { to: '/toolbox', label: 'Toolbox' },
  { to: '/jobs', label: 'Jobs' },
  { to: '/dashboard', label: 'Dashboard' },
  { to: '/schedules', label: 'Schedules' },
];

export default function SiteHeader({ variant = 'marketing' }) {
  const navigate = useNavigate();
  const authed = isDemoAuthenticated();
  const inApp = variant === 'app';

  function handleLogout() {
    logoutDemo();
    navigate('/');
  }

  return (
    <header className={`site-header${inApp ? ' site-header-app' : ''}`}>
      <Link to="/" className="site-brand">
        <img src="/favicon.svg" alt="GIS Liberty" className="site-logo" width="40" height="40" />
        <div>
          <strong>GIS Liberty</strong>
          {inApp ? <span className="site-tagline">Interactive demo</span> : null}
        </div>
      </Link>

      {inApp ? (
        <nav className="site-nav" aria-label="Demo navigation">
          {APP_LINKS.map((link) => (
            <NavLink
              key={link.to}
              to={link.to}
              className={({ isActive }) => `site-nav-link${isActive ? ' active' : ''}`}
            >
              {link.label}
            </NavLink>
          ))}
        </nav>
      ) : null}

      <div className="site-header-actions">
        <ColorModeToggle compact />
        {!inApp ? (
          <>
            <a href="/#how-it-works" className="btn btn-outline btn-sm">
              How it works
            </a>
            <a href="mailto:sales@gis.fm?subject=GIS%20Liberty%20demo%20request" className="btn btn-outline btn-sm">
              Request a demo
            </a>
            {!authed ? (
              <Link to="/login" className="btn btn-primary btn-sm">Try demo</Link>
            ) : (
              <Link to="/toolbox" className="btn btn-primary btn-sm">Open toolbox</Link>
            )}
          </>
        ) : null}
        {authed && inApp ? (
          <button type="button" className="btn btn-outline btn-sm" onClick={handleLogout}>
            Exit demo
          </button>
        ) : null}
        {authed && !inApp ? (
          <button type="button" className="btn btn-outline btn-sm" onClick={handleLogout}>
            Exit demo
          </button>
        ) : null}
      </div>
    </header>
  );
}
